import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Brand from "../components/User/Brand";

export default withRouter(connect()(Brand));
